export const CLAIM_LIST_PATH = '/claims';
export const REPOSIT_LIST_PATH = '/reposits';
export const ORGANISATION_LIST_PATH = '/organisations';
export const USER_LIST_PATH = '/users';

export const CLAIM_DETAIL_PATH = `${CLAIM_LIST_PATH}/:id`;
export const REPOSIT_DETAIL_PATH = `${REPOSIT_LIST_PATH}/:id`;
export const ORGANISATION_DETAIL_PATH = `${ORGANISATION_LIST_PATH}/:id`;
export const USER_DETAIL_PATH = `${USER_LIST_PATH}/:userId`;
